// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2rukU","containerItemsCenter":"Skeleton_containerItemsCenter__2Jt24"};